import { useAppSelector } from "@/redux/hooks";
import ConfigUtils from "@/utils/ConfigUtils";
import { useSplitClient } from "@splitsoftware/splitio-react";

export const useAsyncCheckoutEnabled = () => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const appId = useAppSelector(
    (state) => state.appConfig?.brandAppConfig?.appId
  );
  const appType = useAppSelector(
    (state) => state.appConfig?.brandAppConfig?.appType
  );
  const splitIO = useSplitClient();
  const treatment = splitIO.client?.getTreatment("brandclub_async_checkout", {
    email: userProfile?.email ?? "",
    appId: appId ?? "",
    appType: appType ?? "",
  }) as "v1" | "v2" | "debug";

  const isLocalhost = window.location.href.includes(
    import.meta.env.VITE_APP_LOCALHOST_UI_URL
  );
  const isBeta = ConfigUtils.getAppStage() === "beta";

  return {
    enabled: ["v1", "v2", "debug"].includes(treatment) || isLocalhost || isBeta,
    debug: treatment === "debug",
    showExperimentalCheckout: treatment === "v2" || treatment === "debug" || isLocalhost || isBeta,
  };
};
